import SectionFooter1 from "../app/sections/common/footer/footer1";
import SectionHeader1 from "../app/sections/common/header/header1";
// SectionHeader2 and SectionHeader3 reserved for future use
import { route } from "./constants";
import banner from "../globals/data/banner.json";

const isAdminRoute = (currentpath) => currentpath.startsWith('/admin');

export function showHeader(currentpath) {
    if (currentpath === route.pages.ERROR404) {
        return false;
    }
    if (isAdminRoute(currentpath)) {
        return false;
    }
    return true;
}

export function setFooter(currentpath) {
    // Don't show footer on admin pages
    if (isAdminRoute(currentpath)) {
        return null;
    }
    if (currentpath === route.pages.features.footer.LIGHT) {
        return <SectionFooter1 theme="footer-light" />
    } else {
        return <SectionFooter1 theme="footer-dark" />
    }
}

export function setHeader(currentpath) {
    // Use Header1 for all pages
    return <SectionHeader1 />
}

export const setBannerData = (currentpath) => {
    // Check for dynamic blog detail route (blog/:id)
    const blogDetailMatch = currentpath.match(/^\/blog\/([^/]+)$/);
    if (blogDetailMatch && blogDetailMatch[1] !== 'list' && blogDetailMatch[1] !== 'list-sidebar' && 
        blogDetailMatch[1] !== 'grid' && blogDetailMatch[1] !== 'grid-sidebar' && blogDetailMatch[1] !== 'post-single') {
        return banner.blogDetail;
    }
    
    switch (currentpath) {
        case route.pages.FAQ:
            return banner.faq
        case route.pages.team.TEAM:
            return banner.team
        case route.pages.team.DETAIL:
            return banner.teamDetail
        case route.pages.contact.CONTACT1:
            return banner.contact1
        case route.pages.contact.CONTACT2:
            return banner.contact2
        case route.pages.gallery.GALLERY1:
            return banner.gallery1
        case route.pages.gallery.GALLERY2:
            return banner.gallery2
        case route.pages.ERROR404:
            return banner.error404
        case route.pages.features.footer.FIXED:
            return banner.footerFixed
        case route.pages.features.footer.LIGHT:
            return banner.footerLight
        case route.pages.features.footer.DARK:
            return banner.footerDark
        case route.pages.contact.GET_QUOTE:
            return banner.getQuote
        case route.pages.FEATURE:
            return banner.FEATURE
        case route.services.SERVICES:
            return banner.services
        case route.services.DETAIL:
            return banner.serviceDetail
        case route.blog.LIST:
            return banner.blogList
        case route.blog.LIST_SIDEBAR:
            return banner.blogListSidebar
        case route.blog.GRID:
            return banner.blogGrid
        case route.blog.GRID_SIDEBAR:
            return banner.blogGridSidebar
        case route.blog.POST_SINGLE:
            return banner.blogPostSingle
        case route.shop.PRODUCTS:
            return banner.shopProducts
        case route.shop.DETAIL:
            return banner.shopProductDetail
        case route.shop.CART:
            return banner.shopCart
        case route.shop.WISHLIST:
            return banner.shopWishlist
        case route.shop.CHECKOUT:
            return banner.shopCheckout
        case route.ELEMENTS:
            return banner.elements
        default:
            return banner.about
    }
}